import React from 'react';
import { PrimaryButton, SecondaryButton } from 'src/shared/components/button/Button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/shared/components/ui/dialog';
import useCMSArticle from 'src/shared/hooks/cms/useCMSArticle';
import storageService from 'src/services/storage-service';
import { GNR_OVERVIEW_WELCOME_DIALOG_DISMISSED_STORAGE_KEY } from 'src/shared/constants/storageKeys';
import styles from './GnrWelcome.module.scss';

type GnrWelcomeProps = {
    onExploreMethodology: () => void;
};

const GnrWelcome = ({ onExploreMethodology }: GnrWelcomeProps) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const article = useCMSArticle('gnr-overview-welcome-modal');
    const dialogTitleRef = React.useRef<HTMLHeadingElement>(null);

    React.useEffect(() => {
        const isDismissed = Boolean(storageService.get(GNR_OVERVIEW_WELCOME_DIALOG_DISMISSED_STORAGE_KEY));
        setIsOpen(!isDismissed);
    }, []);

    const closeDialog = React.useCallback(() => {
        storageService.save(GNR_OVERVIEW_WELCOME_DIALOG_DISMISSED_STORAGE_KEY, true);
        setIsOpen(false);
    }, []);

    const handleOpenChange = React.useCallback(
        (open: boolean) => {
            if (!open) closeDialog();
        },
        [closeDialog]
    );

    return (
        <Dialog open={isOpen} onOpenChange={handleOpenChange}>
            <DialogContent
                className='w-[596px] max-w-[calc(100vw-2rem)] rounded-lg'
                onOpenAutoFocus={e => {
                    e.preventDefault();
                    dialogTitleRef.current?.focus();
                }}
            >
                <DialogHeader>
                    <DialogTitle ref={dialogTitleRef} tabIndex={-1} className='text-3xl text-primary font-normal focus:outline-none'>
                        {article?.title}
                    </DialogTitle>
                </DialogHeader>
                {article?.content && <div className={styles.content} dangerouslySetInnerHTML={{ __html: article.content }} />}
                <div className='flex justify-end gap-2'>
                    <SecondaryButton onClick={onExploreMethodology}>Explore the methodology</SecondaryButton>
                    <PrimaryButton onClick={closeDialog}>Get started</PrimaryButton>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default GnrWelcome;
